import DepotsTab from "@features/stock/components/DepotsTab";
import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { Warehouse } from "lucide-react";

export const Route = createFileRoute("/_app/stock/depots")({
  staticData: {
    title: "Dépôts",
    icon: Warehouse,
    permission: "stock.depots.view",
    module: "stock",
    section: "Stock",
    order: 46.5,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  loader: requirePermission("stock.depots.view"),
  component: DepotsTab,
});
